<script setup lang="ts">
import { h } from 'vue';
import type { DashboardEmail, EmailParticipant } from '@apparatix/schemas/DashboardEmails';
import { useDashboardEmails, useUtilities } from '@apparatix/composables';
import { Stack } from '@apparatix/library/core';
import ParticipantTypeChip from '../orphaned-emails/ParticipantTypeChip.vue';
import EmailAddressList from './EmailAddressList.vue';

type Props = {
  participants: DashboardEmail['participants'],
  direction: DashboardEmail['direction'],
};

const props = defineProps<Props>();

const { arrayHasValues } = useUtilities();
const { placeCurrentUserAtStartOfParticipants } = useDashboardEmails();

const renderList = (type: keyof Omit<DashboardEmail['participants'], 'reply_to'>, emailParticipants: EmailParticipant[]) => () => h('div', { class: 'flex items-center gap-1.5' }, [h(ParticipantTypeChip, { type }), h(EmailAddressList, { participants: emailParticipants })]);
</script>
<template>
  <Stack :gap="1" :fluid="false">
    <template v-if="arrayHasValues(props.participants.from)">
      <component :is="renderList('from', props.participants.from)" />
    </template>
    <template v-if="arrayHasValues(props.participants.to)">
      <component :is="renderList('to', props.direction === 'incoming' ? placeCurrentUserAtStartOfParticipants(props.participants.to) : props.participants.to)" />
    </template>
    <template v-if="arrayHasValues(props.participants.cc)">
      <component :is="renderList('cc', props.direction === 'incoming' ? placeCurrentUserAtStartOfParticipants(props.participants.cc) : props.participants.cc)" />
    </template>
    <template v-if="arrayHasValues(props.participants.bcc) && props.direction === 'outgoing'">
      <component :is="renderList('bcc', props.participants.bcc)" />
    </template>
  </Stack>
</template>
